import BlPickerSelectionMv from './BlPickerSelectionMv.vue'

BlPickerSelectionMv.install = function(Vue) {
  Vue.component(BlPickerSelectionMv.name, BlPickerSelectionMv)
}

export default BlPickerSelectionMv
